import CardLayeredFooter from '@liquidweb-dev/undercurrent/CardLayeredFooter';

import VerifyDestroy from 'components/standard/VerifyDestroy';

const ConfirmFooter = () => (
	<CardLayeredFooter
		sx={(theme) => ({
			position: 'relative',
			backgroundColor: theme.vars.palette.uc.danger.bg.main,
			marginTop: -150,
			paddingTop: 300,
			paddingBottom: 200,
			zIndex: 0,
		})}
	>
		<VerifyDestroy sx={{ width: '100%' }} />
	</CardLayeredFooter>
);

export default ConfirmFooter;
